export const MARKETS_SCOPES = [
  'read_markets',
  'write_markets',
  'read_publications',
  'write_publications',
]

// Markets is unlocked on the L *and* XL plans — XL ranks above L in
// `company_package_type` (S < M < L < XL), so checking only `=== 'L'` would
// push XL customers into the upgrade modal. Single source of truth so the
// plan rule isn't duplicated across Overview / Markets / PanelSwitcher /
// MainMenu.
export function isMarketsUnlocked(
  me: { package_type?: string } | null | undefined,
): boolean {
  return me?.package_type === 'L' || me?.package_type === 'XL'
}
